import {MI} from "../init";
import {copyArray, shuffleArray} from "../../framework/src/helpers";
import {he, wi} from "../../framework/src/engine/madnes/madnes_variables";

/**
 * @constructor
 * @returns {ChangeFlyAnim}
 */
export default function ChangeFlyAnim() {}

ChangeFlyAnim.prototype.run = function(particle, obj, delay, onDelay) {

    var toX = obj.getPosX();
    var toY = obj.getPosY();
    var z = true;
    var _self = this;
    
    var path = this._getRandomPath();
    path['x'].push(toX);
    path['y'].push(toY);

/*   MI.createTimer().add(function() {
        onDelay();
    }, 300);
 */
    return new Promise(function(res) {

       var t = MI.addTween().to(particle, { 'x': 1.2, 'y': 1.2 }, {
            'scale': true,
            'duration': 1000,
        })
        
        t.tween.onUpdateCallback(function(){
            
            if (z){
                if (particle.getPosX() <1000 || particle.getPosY() < 200){
                    onDelay();
                    z = false;
                }
            }
        },_self);

        MI.addTween().to(particle, {
            'x': path['x'],
            'y': path['y'],
            'angle': 360
        }, {
            'duration': 1000,
            /*'onStart': function() {
                obj.setVisible(true);
            },*/
            'delay': delay,
            'callback': res
        }).bezier();
    });
};

ChangeFlyAnim.prototype._getRandomPath = function() {

    var pos = shuffleArray(copyArray([
        [wi, 0],
        [0, he]
    ]));

    var x = [];
    var y = [];

    for(var i = 0; i < pos.length; i++) {
        x.push(pos[i][0]);
        y.push(pos[i][1]);
    }

    return {
        'x': x,
        'y': y
    };
};